(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServantsDialogController', CompanyServantsDialogController);

    CompanyServantsDialogController.$inject = ['__config', '$timeout', '$scope', '$stateParams', '$state', 'entity', 'Servant', 'PersonInfo', 'ServiceCategory', 'ServiceItem', 'PriceInfo', 'ServantCustom', 'CompanyCustom', '$translate', '$mdToast', '$mdDialog', '$rootScope', 'ServiceItemCustom'];

    function CompanyServantsDialogController(__config, $timeout, $scope, $stateParams, $state, entity, Servant, PersonInfo, ServiceCategory, ServiceItem, PriceInfo, ServantCustom, CompanyCustom, $translate, $mdToast, $mdDialog, $rootScope, ServiceItemCustom) {
        var vm = this;

        vm.scope = $scope;
        vm.servant = entity;
        vm.hasEoTimeRange = false;
        if (vm.servant && vm.servant.id != null) {
            var now = new Date();
            now.setDate(now.getDate() - 1);
            now.setHours(0);
            now.setMinutes(0);
            now.setSeconds(0);
            var tempArr = [];
            vm.showAmenities = false;
            vm.showImageGallery = false;
            vm.showTags = false;
            vm.isWorkSpace = false;
            vm.servantTranslate = $translate.instant('tikonApp.servant.home.title');
            vm.__config = __config;
            vm.showLimitDates = false;
            vm.showLimitDateChange = showLimitDateChange;
            vm.addClosedTimes = addClosedTimes;
            vm.addOpenTimes = addOpenTimes;
            vm.setTabActive = setTabActive;


            angular.forEach(vm.servant.scheduleInfo.scheduleExceptionDurations, function (exDate) {
                if (new Date(exDate.startDate) > now) {
                    tempArr.push(exDate);
                }
            })
            vm.servant.scheduleInfo.scheduleExceptionDurations = tempArr;
        }
        // vm.servant.status = 'ACTIVE';
        vm.clear = clear;
        vm.save = save;
        vm.tabSelector = tabSelector;
        vm.orderedTabSelected = true;
        //vm.personinfos = PersonInfo.query();
        vm.serviceList = [];
        vm.hasNotNewSchedule = hasNotNewSchedule;
        vm.hasNewSchedule = hasNewSchedule;
        vm.setEdited = setEdited;
        vm.updatePrice = updatePrice;
        vm.editBtnPressed = [];
        vm.showServantSchedule = true;
        vm.showServantCloseTimes = false;
        vm.getNavItemClass = getNavItemClass;
        vm.serviceListEmptyMessage = "این پرسنل هیچ سرویسی ارائه نمی دهد";


        vm.allCompanyServiceList = [];


        loadAll();

        function loadAll() {
            loadAllCompanyServiceList();
        }

        checkCompanyActivityType();
        $scope.$watch('vm.servant', function (servant) {

            if (servant) {
                if (servant.scheduleInfo && !servant.scheduleInfo.baseScheduleMode)
                    servant.scheduleInfo.baseScheduleMode = 'BASED_ON_COMPANY';
                if (servant.id)
                    ServantCustom.serviceItemScheduleByServantId(servant.id).query(function (result) {
                        vm.serviceList = result;
                        checkShowLimitDates();

                    });

            }


        })

        // $timeout(function (){
        //     angular.element('.form-group:eq(1)>input').focus();
        // });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function tabSelector() {
            vm.orderedTabSelected = !vm.orderedTabSelected;
        }

        function save() {

            if (vm.isWorkSpace)
                vm.servant.personInfo.lastName = ' ';

            prepareServiceItemListForSave();
            vm.isSaving = true;
            if (vm.servant.id !== null) {
                Servant.update(vm.servant, onSaveSuccess, onSaveError);
            } else {
                Servant.save(vm.servant, function (result) {

                    $state.go('supplierPanel.companyServants.edit', {id: result.id});

                }, onSaveError);
            }
        }

        function onSaveSuccess(result) {

            ServantCustom.saveScheduleList().update(vm.serviceList, function () {
                $scope.$emit('tikonApp:servantUpdate', result);
                // vm.serviceList=ServantCustom.serviceItemScheduleByServantId(servant.id).query(function(result){
                //     vm.servant=result;
                // });

                vm.isSaving = false;

            })

            if (result.videoCallSettingInfo && result.videoCallSettingInfo.id) {
                vm.servant.videoCallSettingInfo = result.videoCallSettingInfo;
            }

        }

        function setEdited(ssi) {

            ssi.edited = (!ssi.edited);
        }

        function hasNewSchedule(ssi) {
            ssi.scheduleInfo.hasNewSchedule = true;
        }

        function hasNotNewSchedule(ssi) {
            ssi.scheduleInfo.hasNewSchedule = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function updatePrice(serviceItemId, priceInfo, index) {

            ServantCustom.updateServantService(serviceItemId, vm.servant.id).save(priceInfo, function (result) {

                priceInfo = result;
                $scope.$emit('tikonApp:servantUpdate', result);
                vm.isSaving = false;
                vm.editBtnPressed[index] = false;
            })

        }

        function checkCompanyActivityType() {

            if (vm.servant.company) {
                if (vm.servant.company.activityType == "WORK_SPACE")
                    vm.isWorkSpace = true;

            } else {
                CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                    if (result.activityType == "WORK_SPACE")
                        vm.isWorkSpace = true;
                })
            }

            if (vm.isWorkSpace) {
                vm.showAmenities = false;
                vm.showImageGallery = false;
                vm.showTags = false;
                vm.isWorkSpace = true;
                setServantTranslate();
            }
        }

        function setServantTranslate() {

            if (vm.isWorkSpace) {
                vm.servantTranslate = $translate.instant('tikonApp.servant.home.title-space');
            }
        }


        $scope.ActiveServiceFilter = function (item) {
            return item.serviceItem.serviceStatus != 'DISABLE';
        };
        $scope.ValidPriceInfoFilter = function (item) {
            return true;
            //   return (item.priceInfoDtails && item.priceInfoDtails.length>0);
        };


        var last = {
            bottom: false,
            top: true,
            left: true,
            right: false
        };

        vm.toastPosition = angular.extend({}, last);

        vm.getToastPosition = function () {
            sanitizePosition();

            return Object.keys(vm.toastPosition)
                .filter(function (pos) {
                    return vm.toastPosition[pos];
                }).join(' ');
        };

        function sanitizePosition() {
            var current = vm.toastPosition;

            if (current.bottom && last.top) {
                current.top = false;
            }
            if (current.top && last.bottom) {
                current.bottom = false;
            }
            if (current.right && last.left) {
                current.left = false;
            }
            if (current.left && last.right) {
                current.right = false;
            }

            last = angular.extend({}, current);
        }

        function showLimitDateChange(showLimitDates, datePeriod) {
            if (!showLimitDates) {
                datePeriod.fromDate = null;
                datePeriod.toDate = null;

            }

        }

        function checkShowLimitDates() {
            if (vm.servant.scheduleInfo.weeklyScheduleInfo.datePeriod.fromDate ||
                vm.servant.scheduleInfo.weeklyScheduleInfo.datePeriod.endDate
            ) {
                vm.showLimitDates = true;
            }


            angular.forEach(vm.serviceList, function (ssi) {
                if (ssi.scheduleInfo.weeklyScheduleInfo.datePeriod.fromDate ||
                    ssi.scheduleInfo.weeklyScheduleInfo.datePeriod.toDate
                ) {
                    ssi.showLimitDates = true;
                }
            })

        }

        function setTabActive(tabName) {
            switch (tabName) {
                case 'servantSchedule':
                    vm.showServantSchedule = true;
                    vm.showServantCloseTimes = false;
                    vm.showServantOpenTimes = false;
                    break;
                case 'servantCloseTimes':
                    vm.showServantSchedule = false;
                    vm.showServantCloseTimes = true;
                    vm.showServantOpenTimes = false;
                    break;
                case 'servantOpenTimes':
                    vm.showServantSchedule = false;
                    vm.showServantCloseTimes = false;
                    vm.showServantOpenTimes = true;
                    break;
            }
        }

        function getNavItemClass(itemName) {
            switch (itemName) {
                case 'servantSchedule':
                    if (vm.showServantSchedule)
                        return 'my-nav-button-active';
                    else
                        return '';
                case 'servantCloseTimes':
                    if (vm.showServantCloseTimes)
                        return 'my-nav-button-active';
                    else
                        return '';
                case 'servantOpenTimes':
                    if (vm.showServantOpenTimes)
                        return 'my-nav-button-active';
                    else
                        return '';
            }
        }

        function loadAllCompanyServiceList() {
            if (!vm.servant || !vm.servant.id)
                return;
            ServiceItemCustom.getServiceItemWithServantsByCurrentCompany().query(function (result) {
                vm.allCompanyServiceList = result;
                ServiceItemCustom.getServiceItemsByServantId(vm.servant.id).query(function (list) {
                    vm.allServantServices = list;
                    makeServantServiceList();
                })

            });
        }

        function makeServantServiceList() {
            angular.forEach(vm.allCompanyServiceList, function (allItem) {
                angular.forEach(vm.allServantServices, function (service) {
                    if (allItem.id == service.id)
                        allItem.checked = true;
                })
                if (allItem.serviceMode && allItem.serviceMode == 'EVENT')
                    allItem.canRemoveCheck = false;
                else {
                    if (allItem.servants && allItem.servants.length > 1) {
                        allItem.canRemoveCheck = true;
                    } else {
                        allItem.canRemoveCheck = false;
                    }
                }
            })
        }

        function prepareServiceItemListForSave() {

            if (vm.allCompanyServiceList) {
                vm.servant.serviceItemList = [];
                angular.forEach(vm.allCompanyServiceList, function (item) {
                    if (item.checked)
                        vm.servant.serviceItemList.push(item);
                })
            }
        }

        function addClosedTimes() {
            addServantExceptionTimes('CLOSE');
        }

        function addOpenTimes() {
            addServantExceptionTimes('OPEN');
        }

        function addServantExceptionTimes(mode) {

            $mdDialog.show({
                templateUrl: 'app/components/partial-forms/servant-exception-duration/partial-form.servant-exception-duration.html',
                controller: 'ServantExceptionDurationComponentController',
                controllerAs: '$ctrl',
                resolve: {
                    entity: (function () {
                        return {
                            defaultServantId: vm.servant.id,
                            availabilityMode: mode,
                            canSelectServant: false

                        };
                    })

                },
                // parent: angular.element(document.body),
                // targetEvent: customerFormData,
                clickOutsideToClose: true
            }).then(function (v) {
                reloadServantExceptionDurations();
            }, function () {
                //nothing
            });


        }

        function reloadServantExceptionDurations() {
            $rootScope.$broadcast('reloadServantExceptionDurationListEvent');
        }
    }
})();
